import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { StatusCode, SelectionType } from '../../_enums/Common';
import { ListingParams } from '../../_models/common/listingParams';
import { CommonService } from '@services/app.common.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AutoCompleteModalComponent } from '../app-AutoCompleteModal/app-AutoCompleteModal.component';
import { AutoCompleteConfig } from '../../_models/common/AutoCompleteConfig';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './app-AutoComplete.component.html'
})

export class AutoCompleteComponent implements OnInit {
  private _valueModel: any;

  @Input('valueModel')
  get valueModel() {
    return this._valueModel;
  }
  set valueModel(val) {
    this._valueModel = val;
    this.valueModelChange.emit(this._valueModel);
  }

  @Input() autoCompleteConfig = {} as AutoCompleteConfig;

  @Output() valueModelChange = new EventEmitter();
  @Output() bySelect = new EventEmitter();
  @Output() searchClick = new EventEmitter();

  userInput: string = "";
  isAsync: boolean = false;
  typeaheadLoading: boolean=false;
  dataSourceArray: any;
  modalRef = {} as BsModalRef;

  @ViewChild('input', { static: true }) inputRef?: ElementRef;


  statusCode = StatusCode;
  listingParams = {} as ListingParams;


  constructor(private common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.listingParams = this.common.initListingParams();
    this.autoCompleteConfig.label = this.autoCompleteConfig.label ? this.autoCompleteConfig.label : null??"";
    this.autoCompleteConfig.nameAttribute = this.autoCompleteConfig.nameAttribute ? this.autoCompleteConfig.nameAttribute : null ?? "";
    this.autoCompleteConfig.dataSourceUrl = this.autoCompleteConfig.dataSourceUrl ? this.autoCompleteConfig.dataSourceUrl : null ?? "";
    this.autoCompleteConfig.optionValueField = this.autoCompleteConfig.optionValueField ? this.autoCompleteConfig.optionValueField : 'id';
    this.autoCompleteConfig.placeholder = this.autoCompleteConfig.placeholder ? this.autoCompleteConfig.placeholder : null ?? "";
    this.autoCompleteConfig.required = this.autoCompleteConfig.required ? this.autoCompleteConfig.required : null ?? false;
    this.autoCompleteConfig.showSearchIcon = this.autoCompleteConfig.showSearchIcon ? this.autoCompleteConfig.showSearchIcon : false;
    this.autoCompleteConfig.allowCustomInput = this.autoCompleteConfig.allowCustomInput ? this.autoCompleteConfig.allowCustomInput : false;



    if (this.autoCompleteConfig.dataSourceUrl) {
      this.isAsync = true;

      this.autoCompleteConfig.dataSource = Observable.create((observer: any) => {
        this.listingParams.textToSearch = this.userInput;
        this.listingParams.systemPageId = this.autoCompleteConfig.systemPageId??-1;

        this.common.PostData(this.autoCompleteConfig.dataSourceUrl??"", this.listingParams, false)
          .then(result => {
            if (result.status == this.statusCode.OK) {
              this.dataSourceArray = result.resultData.listData;
              observer.next(result.resultData.listData);
            } else {
              this.dataSourceArray = null;
              this.typeaheadLoading = false;
            }
          })
          .catch((err) => {
            this.dataSourceArray = null;
            this.typeaheadLoading = false;
          });
      });
    }

    if (this.autoCompleteConfig.dataSource) {
      if (Array.isArray(this.autoCompleteConfig.dataSource)) {
        this.dataSourceArray = this.autoCompleteConfig.dataSource;
      }
    } else {
      this.autoCompleteConfig.dataSource = [];
      console.error(`No dataSourceUrl/dataSource array provided for ${this.autoCompleteConfig.label} autocomplete. So, it will not work.`);
    }
  }

  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  typeaheadOnSelect(eventArgs: TypeaheadMatch): void {
    if (eventArgs.item) {
      this.valueModel = eventArgs.item[this.autoCompleteConfig.optionValueField??""];
      this.UpdateFormControl();
    }
    this.bySelect.emit(eventArgs);
  }

  onChange() {
    let matchingItem = null;
    if (this.dataSourceArray && Array.isArray(this.dataSourceArray)) {
      const dataArray = this.dataSourceArray as Array<any>;
      matchingItem = dataArray.find(a => (a[this.autoCompleteConfig.optionTextField??""] as string).trim().toLowerCase() == this.userInput.trim().toLowerCase());
    }

    if (matchingItem) {
      this.userInput = matchingItem[this.autoCompleteConfig.optionTextField??""];
      this.valueModel = matchingItem[this.autoCompleteConfig.optionValueField??""];
      this.UpdateFormControl();
      this.bySelect.emit(new TypeaheadMatch(matchingItem));
    } else {
      if (!this.autoCompleteConfig.allowCustomInput) {
        this.userInput = null??"";
      }

      this.valueModel = null;
      this.UpdateFormControl();
      this.bySelect.emit(new TypeaheadMatch(null));
    }
  }

  private UpdateFormControl() {
    if (this.autoCompleteConfig.formCtrl) {
      this.autoCompleteConfig.formCtrl.patchValue(this.valueModel);
    }
  }

  onSearchClick() {
    if (this.searchClick.observers.length > 0) {    // if search click event is handled in the host/parent component
      this.searchClick.emit(this.userInput);
    } else {
      if (this.autoCompleteConfig.dataSourceUrl) {
        this.common.listingParams.systemPageId = this.autoCompleteConfig.systemPageId??-1;
        this.common.listingParams.getUrl = this.autoCompleteConfig.dataSourceUrl;
        this.common.listingParams.isSearchEnabled = false;
        this.common.listingParams.selectionType = SelectionType.Single;

        const initialState = {
          listingParams: this.common.listingParams,
          autoCompleteConfig: this.autoCompleteConfig
        };

        this.modalService.onHide.subscribe((reason: string) => {
          if (this.modalRef.content && this.modalRef.content.selectedItems && this.modalRef.content.selectedItems[0]) {
            const selectedItem = this.modalRef.content.selectedItems[0];

            this.userInput = selectedItem[this.autoCompleteConfig.optionTextField??""];
            this.valueModel = selectedItem[this.autoCompleteConfig.optionValueField??""];
            this.UpdateFormControl();
            this.bySelect.emit(new TypeaheadMatch(selectedItem));
          }
        });

        this.modalRef = this.modalService.show(AutoCompleteModalComponent, { initialState, class: 'modal-wide' });
      }
    }
  }
}
